import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LocusRobotics_ds_get_job_prioritizationService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { orderId?: number }): 
  Promise<{ result: { Id?: number, OutboundPriorityId?: number, RequestedDeliveryDate?: string, ShipmentOrderLookups?: { OrderId?: number, ShipmentId?: number, Shipment?: { Id?: number, AvailableDate?: string, DateNeeded?: string, DatePromised?: string, ExpectedDate?: string, Priority?: number, Carrier?: { Id?: number, Name?: string, ScacCode?: string, ShortName?: string, Services?: { Name?: string, Service_Type?: string, ServiceClass?: string, ServiceGroup?: string, ServiceMode?: string }[] }, CarrierServiceType?: { Id?: number, Name?: string, ShortName?: string } } }[], Project?: { LookupCode?: string, Name?: string } } }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
